import React from 'react'
import PropTypes from 'prop-types'

import Box from 'suitTheme/Box'
import Text from 'suitTheme/Text'

import styles from './styles.scss'

const Result = (props) => {
  const {
    onClick, result: {
      iconLeft, iconRight, secondaryText, text,
    },
  } = props

  return (
    <Box
      alignItems="center"
      borderBottom="1px dashed"
      borderColor="lineColor"
      className={styles.root}
      flexShrink="0"
      onClick={onClick}
      paddingY="medium"
    >
      {iconLeft}
      <Box flexDirection="column" marginLeft={iconLeft ? 'medium' : null}>
        <Text fontSize="small">
          {text}
        </Text>
        {secondaryText && (
          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
            {secondaryText}
          </Text>
        )}
      </Box>
      {iconRight}
    </Box>
  )
}

Result.propTypes = {
  onClick: PropTypes.func,
  result: PropTypes.shape({
    iconLeft: PropTypes.node,
    iconRight: PropTypes.node,
    secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  }).isRequired,
}

export default Result
